import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Card, CardBody } from 'reactstrap'

import CallLogsTable from './partials/CallLogsTable'
import ListTopBar from '../../components/ListTopBar'

import { getCallLogs } from './services'
import { handleError, parsePagination } from '../../helpers'

export default function CallLogsList() {
	const user = useSelector(state => state.auth.user)
	const [callLogs, setCallLogs] = useState(null)
	const [filterType, setFilterType] = useState('client_doc')
	const [filterValue, setFilterValue] = useState('')
	const [pagination, setPagination] = useState({page: 1, per_page: 15, total: 0})

	useEffect(() => {
		!callLogs && getCallLogs({
			[`filter[${filterType}]`]: filterValue,
			'filter[agent_doc]': user.document,
			include: 'invoice.customer',
			sort: '-created_at',
			...pagination,
		})
			.then(res => {
				setCallLogs(res.data.data)
				setPagination(parsePagination(res))
			})
			.catch(error => handleError(error))
	}, [ callLogs, filterType, filterValue, pagination, user ])

	return (
		<React.Fragment>
			<ListTopBar 
				filterType={filterType}
				setFilterType={setFilterType}
				filterValue={filterValue}
				setFilterValue={setFilterValue}
				title={`Llamadas de Seguimiento Asesor C.C. ${user.document}`}
				subtitle="Recompra Fiel Momentos Spring"
				reload={() => setCallLogs(null)}
				options={[
					{ label: 'Buscar cédula del cliente', value: 'client_doc' },
				]}
			/>
			<Card>
				<CardBody>
					<CallLogsTable
						callLogs={callLogs}
						reload={() => setCallLogs(null)}
						pagination={pagination}
						setPagination={setPagination}
					/>
				</CardBody>
			</Card>
		</React.Fragment>
	)
}